module.exports = __webpack_public_path__ + "static/media/clock.59e18a03.png";